import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BoxesRegular from './boxes-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BoxesRegular {...validProps} />;
}
SvgComponent.iconName = 'boxesRegular';

export const BoxesRegularIcon = svgIconWrapper(SvgComponent);
